fragment ProductGridFragment on productGrid_Entry {
  typeHandle
}
